import { render, staticRenderFns } from "./por_sede.vue?vue&type=template&id=64ac52e4"
import script from "./por_sede.vue?vue&type=script&lang=js"
export * from "./por_sede.vue?vue&type=script&lang=js"
import style0 from "./por_sede.vue?vue&type=style&index=0&id=64ac52e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports